import {TARGETING_COOKIES, IRE_CLICK_ID} from 'constants/analytics';
import {waitForActivatingCookieGroup} from 'features/oneTrust/oneTrust';
import {localStore} from 'libs/storage/storage';

/**
 * Save generated click ID to local storage.
 *
 * @param {string} id - Generated click ID.
 */
export const saveClickIdToStore = (id: string) => {
    localStore.set(IRE_CLICK_ID, id);
};

/**
 * Generate click ID.
 */
export const generateClickId = () => {
    if (__NODEJS__) return;
    const ireClickId = localStore.get(IRE_CLICK_ID);
    if (!ireClickId && window.ire) window.ire('generateClickId', saveClickIdToStore);
};

/**
 * Preparing to generate Click Id.
 */
export const preparationGenerateClickId = async () => {
    try {
        await waitForActivatingCookieGroup(TARGETING_COOKIES);
        generateClickId();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
